import { FC } from "react";

const NavBar: FC = () => {
    return (
        <div className="row">
            <nav
                className="navbar navbar-expand-lg fixed-top navbar-north"
                role="navigation"
                id="navbarNorth"
            >
                <div className="container" id="navbarNorthContainer">
                    <div className="row no-gutters">
                        <div className="col-lg-2">
                            <header>
                                <a
                                    href="/"
                                    className="logotype logotype-white"
                                    role="banner"
                                >
                                    Sweco
                                </a>
                            </header>
                        </div>
                    </div>
                </div>
                <div id="progress-container" className="progress-navbar"></div>
            </nav>
        </div>
    );
};

export default NavBar;
